module.exports = __webpack_public_path__ + "fonts/Baloo2-Medium.1f41387.ttf";